import { render } from "./prevOpStatus.vue?vue&type=template&id=0b2e89e3"
import script from "./prevOpStatus.vue?vue&type=script&lang=js"
export * from "./prevOpStatus.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\FrankCastelijns\\bzx_status\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__